import _merge from 'lodash/merge';
import { Lightning } from '@lightningjs/sdk';
import { CIRCLE_MARGIN_RIGHT, CIRCLE_SIZE, defaultContext, getInitialStyle } from './pairingStep.style';

export class PairingStep extends Lightning.Component {
  static _template() {
    return _merge(
      {
        Circle: {
          shader: {
            type: Lightning.shaders.RoundedRectangle,
          },
        },
        DigitContainer: {
          Digit: {},
        },
        Title: {},
      },
      getInitialStyle(),
    );
  }

  _construct() {
    this._style = defaultContext;
  }

  _active() {
    const { screenSize } = this._style;
    const circleSize = CIRCLE_SIZE[screenSize];
    const title = this.tag('Title');
    title.on('txLoaded', () => {
      const textHeight = title.finalH;
      this.patch({
        h: Math.max(textHeight, circleSize),
      });
    });
  }

  _inactive() {
    this.tag('Title').removeAllListeners('txLoaded');
  }

  get digit() {
    return this.tag('Digit').text.text;
  }

  set digit(value) {
    this.tag('Digit').text.text = value;
  }

  get title() {
    return this.tag('Title').text.text;
  }

  set title(value) {
    this.tag('Title').text.text = value;
  }

  get w() {
    return super.w;
  }

  set w(value) {
    super.w = value;
    const { screenSize } = this._style;
    // WARN: only static values are supported
    this.patch({
      Title: {
        text: {
          wordWrapWidth: value - CIRCLE_SIZE[screenSize] - CIRCLE_MARGIN_RIGHT[screenSize],
        },
      },
    });
  }
}
